module.exports = __webpack_public_path__ + "img/beneficiaries-o.e624686e.svg";